import classNames from 'classnames';

import {
  Button,
  ButtonProps,
  ButtonSize,
  ButtonVariant,
  ButtonWithState,
  ButtonWithStateProps,
} from '@xemplo/button';

import * as S from './prompt-footer.styles';

export type BtnWithLabel = ButtonProps & { label: string };
export type FooterProps = {
  btnPrimary?: ButtonWithStateProps & { label?: string };
  btnSecondary?: BtnWithLabel;
  btnTertiary?: BtnWithLabel;
  extended?: boolean;
};

export function PromptFooter(props: Readonly<FooterProps>) {
  const { btnPrimary, btnSecondary, btnTertiary, extended } = props;
  const hasPrimaryAndSecondary = !!(btnPrimary && btnSecondary);
  const hasPrimaryOrSecondary = !!btnPrimary || !!btnSecondary;
  const hasOnlyTertiary = !!btnTertiary && !hasPrimaryOrSecondary;
  return (
    <S.PromptFooter className={classNames({ extended, hasOnlyTertiary })}>
      <S.PrimarySecondaryContainer
        className={classNames({
          extended,
          hasPrimaryOrSecondary: !hasPrimaryAndSecondary,
        })}
      >
        {btnPrimary ? (
          <ButtonWithState
            className="primaryBtn"
            size={ButtonSize.Standard}
            {...btnPrimary}
          >
            {btnPrimary.label}
          </ButtonWithState>
        ) : null}
        {btnSecondary ? (
          <Button
            size={ButtonSize.Standard}
            className="secondaryBtn"
            variant={ButtonVariant.Dark}
            {...btnSecondary}
          >
            {btnSecondary.label}
          </Button>
        ) : null}
      </S.PrimarySecondaryContainer>
      {btnTertiary ? (
        <S.TertiaryContainer className={classNames({ extended })}>
          <Button
            size={ButtonSize.Small}
            className="tertiaryBtn"
            variant={ButtonVariant.Dark}
            {...btnTertiary}
          >
            {btnTertiary.label}
          </Button>
        </S.TertiaryContainer>
      ) : null}
    </S.PromptFooter>
  );
}
